import React from 'react';
import classNames from 'classnames';
import Icons from 'assets/icons';

interface LoaderProps {
  loading?: boolean;
  customClass?: string;
  overlay?: string;
  zIndex?: string;
  overlayClassName?: string;
  spinnerClassName?: string;
  fullScreen?: boolean;
}

const Loader = ({
  loading,
  customClass,
  overlay = 'gray-100',
  zIndex = 'z-[100]',
  overlayClassName,
  spinnerClassName,
  fullScreen = true,
}: LoaderProps): React.JSX.Element | null =>
  loading ? (
    <div
      className={classNames(
        'inset-0 bg-gray-100',
        customClass,
        zIndex,
        fullScreen ? 'fixed' : 'absolute'
      )}
      data-testid="loader"
    >
      <div
        className={classNames(
          'absolute inset-0 opacity-30',
          `bg-${overlay}`,
          overlayClassName
        )}
      />
      <div
        className={classNames(
          'absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2',
          spinnerClassName
        )}
      >
        <div role="status">
          <Icons.Spinner customClass="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-900" />
          <div className="loading loading:after">Loading</div>
        </div>
      </div>
    </div>
  ) : null;

export default Loader;
